/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import * as moment from 'moment'
import { CONFIGS } from '../configs';

import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Collapse,
  Modal,
  Table
} from "react-bootstrap";

class ShopInsight extends Component {
  constructor() {
    super();
    this.state = {
      
    }
  }

  componentDidMount() {
   
  }

  componentWillReceiveProps(props) {
    
  }

  render() {
    return (
      <>
        <Container fluid id="shop-insight">
          <h2 className='text-center'>Shop Insight</h2>

          <Row>
            
          </Row>
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

export default connect(mapStateToProps, {

})(ShopInsight); 